import {useTranslation} from 'react-i18next'
import {AmberDot} from '@/components/amber-dot'
import {cn} from '@/lib/utils'
import type {CandidatoIdentidad} from '@/lib/bateria-cola'

/** G14. Los candidatos son propuesta (punto ámbar): nada se decide hasta pulsar el botón con el nombre. */
export function ListaCandidatos({
  candidatos,
  paqueteElegido,
  onElegir,
  testId,
  deshabilitada = false,
}: {
  candidatos: CandidatoIdentidad[]
  paqueteElegido: string | null
  onElegir: (indice: number) => void
  testId: string
  /** Mientras la hoja no esté en pantalla (interlock de la cola). */
  deshabilitada?: boolean
}) {
  const {t} = useTranslation()
  if (candidatos.length === 0) {
    return (
      <p className="text-sm text-muted-foreground" data-testid={`${testId}-sin-candidatos`}>
        {t('admin.bateria.cola.ubicar.sinCandidatos')}
      </p>
    )
  }
  return (
    <ol className="space-y-1.5" data-testid={`${testId}-candidatos`}>
      {candidatos.map((candidato, i) => {
        const elegido = paqueteElegido === candidato.paquete_id
        const pagina =
          candidato.numero_pagina_probable !== null
            ? t('admin.bateria.cola.ubicar.candidatoPagina', {numero: candidato.numero_pagina_probable})
            : null
        return (
          <li key={candidato.paquete_id}>
            <button
              type="button"
              data-testid={`${testId}-candidato-${i + 1}`}
              disabled={deshabilitada}
              onClick={() => onElegir(i)}
              className={cn(
                'flex min-h-11 w-full items-center gap-2 rounded-md border px-3 py-2 text-left text-sm transition-colors disabled:cursor-default',
                elegido ? 'border-primary bg-accent text-foreground' : 'border-input hover:border-primary/40'
              )}>
              <span className="font-mono text-xs text-muted-foreground">{i + 1}</span>
              {!elegido && <AmberDot label={t('common.senal.pendiente')} />}
              <span className="min-w-0 flex-1 truncate">
                {candidato.persona} · {t('admin.bateria.formaValue', {forma: candidato.forma})}
                {pagina && ` · ${pagina}`}
              </span>
            </button>
          </li>
        )
      })}
    </ol>
  )
}
